import { HighlightStyle, syntaxHighlighting } from "@codemirror/language";
import { syntaxHighlightStyles } from "../../syntaxHighlightStyles";

export const highlight = syntaxHighlighting(
  HighlightStyle.define(
    syntaxHighlightStyles.map(({ tag, color, fontStyle }) => ({
      tag,
      color,
      ...(fontStyle ? { fontStyle } : {}),
    }))
  ),
  { fallback: true }
);
